module.exports = __webpack_public_path__ + "img/eye-svgrepo-com.5b90a99b.svg";